import * as React from 'react';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import FeedbackIcon from '@material-ui/icons/Feedback';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { SupportRequestPayload } from 'src/reducers/supportRequest';
import { connect } from 'react-redux';
import { AppState } from 'src/redux';
import { Dispatch } from 'redux';
import { submitSupportFeedback } from 'src/actions/supportPageAction';
import { push } from 'react-router-redux';

export interface FeedbackPageViewProps {
    onSubmit: (payload: SupportRequestPayload) => void;
    onReset: () => void;

    ticketno: string;
    date: string;
    mtype: string;
    caseno: string;
}

const labels: { [index: string]: string } = {
    1: 'Useless',
    2: 'Poor',
    3: 'Ok',
    4: 'Good',
    5: 'Excellent',
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '100%',
        },
        fontValues: {
            '& .MuiTypography-body1': {
                fontSize: '0.8rem'
            }
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        submit: {
            margin: theme.spacing(1),
            alignItems: 'center'
        },
        rating: {
            margin: theme.spacing(1),
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '1rem',
        },
        rating_In: {
            // fontSize: '2.2rem',
            color: '#f50057'
        },
        card: {
            marginTop: theme.spacing(1),
            transition: theme.transitions.create(['all'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        fontCenter: {
            '& .MuiInputBase-input.Mui-disabled': {
                textAlign: 'center'
            }
        },
        gridList: {
            width: 'auto',
            height: 'auto',
        },
        colorHeading: {
            color: 'rgb(3, 129, 237)'
        }
    })
);

const Cards = withStyles({
    root: {
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '8px'
        },
    }
})(Card);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const SupportFeedbackPageView: React.StatelessComponent<FeedbackPageViewProps> = props => {
    const classes = useStyles({});
    const [hover, setHover] = React.useState(-1);

    const [rating, saveRating] = React.useState(0);
    const [comments, saveComments] = React.useState('');

    const reset = () => {
        saveRating(0);
        saveComments('');
        props.onReset();
    };

    const submit = () => {
        const ratingStr = rating.toString();
        if (comments === '') {
            props.onSubmit({
                ticketno: props.ticketno,
                status: ratingStr,
                comments: labels[rating],
                orderno: props.caseno
            });
        } else {
            props.onSubmit({
                ticketno: props.ticketno,
                status: ratingStr,
                comments: comments,
                orderno: props.caseno
            });
        }
    };

    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <div className={classes.paper}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <FeedbackIcon />
                            </Avatar>}
                        title={<Typography component="h1" variant="h5">Feedback</Typography>}
                    />
                    <div className={classes.form}>
                        <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={1} justify="space-between">
                                    <Grid item xs={12} sm={2} md={2}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Ticket No"
                                            disabled
                                            defaultValue=""
                                            value={props.ticketno !== '' ? props.ticketno : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Support Type"
                                            disabled
                                            defaultValue=""
                                            value={props.mtype !== '' ? props.mtype : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Case No"
                                            disabled
                                            defaultValue=""
                                            value={props.mtype !== '' ? props.caseno : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Date"
                                            disabled
                                            defaultValue=""
                                            value={props.date !== '' ? props.date : '-'}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards>
                        <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={1} justify="space-between">
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.rating}>
                                            Rating :
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.rating}>
                                            <Rating
                                                size="large"
                                                className={classes.rating_In}
                                                name="hover-feedback"
                                                value={rating}
                                                precision={1}
                                                onChange={(event, newValue) => {
                                                    saveRating(newValue as number);
                                                }}
                                                onChangeActive={() => {
                                                    setHover(hover);
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.rating}>
                                            {rating !== null && <Box style={{ justifyContent: 'center' }}>{labels[hover !== -1 ? hover : rating]}</Box>}
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards>
                        <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            label="Comments"
                                            autoFocus
                                            multiline
                                            rowsMax={4}
                                            value={comments}
                                            onChange={event => saveComments(event.target.value as string)}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards>
                        <Grid container spacing={1} justify="center">
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => submit()}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                >
                                    Send Feedback
                                </Button>
                            </Grid>
                            <Grid item xs={4} sm={3} md={2}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.submit}
                                    onClick={() => reset()}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Container>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        ticketno: state.supportRequest.ticketno,
        date: state.supportRequest.date,
        mtype: state.supportRequest.mtype,
        caseno: state.supportRequest.caseno
    };
}

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: (payload: SupportRequestPayload) => {
            dispatch(submitSupportFeedback(payload));
        },
        onReset: () => {
            dispatch(push('/app/supportchat'));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupportFeedbackPageView);



// WEBPACK FOOTER //
// ./src/components/layouts/SupportFeedbackView.tsx